import { object, ref, string } from "yup";

import IUser from "@/interfaces/user.interface";
import { PASSWORD_REGEX } from "@/helpers/string-helpers";
import { ProfileMessages } from "@/messages/profile/profile.messages";

import { ChangePasswordFormData } from "./types";

export const changePasswordFormNames: Record<keyof ChangePasswordFormData, string> = {
  login: "login",
  oldPassword: "oldPassword",
  newPassword: "newPassword",
  confirmPassword: "confirmPassword",
};

export const buildChangePasswordFormInitialData = (user: IUser): ChangePasswordFormData => {
  return {
    login: user.email,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
};

export const buildChangePasswordFormSchema = (messages: ProfileMessages) =>
  object().shape({
    oldPassword: string().required(messages.passwordRequired),
    newPassword: string()
      .required(messages.passwordRequired)
      .matches(
        PASSWORD_REGEX,
        messages.passwordFormatError
      ),
    confirmPassword: string()
      .required(messages.passwordRequired)
      .matches(
        PASSWORD_REGEX,
        messages.passwordFormatError
      )
      .oneOf([ref("newPassword")], messages.passwordNotMatching),
  });
